import React from "react";
import { Button } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

const styleDev = {
  //    background: "red",  // For dev purposes: Uncomment this to see the state of when it's being confirmed
  //    boxShadow: "10px 10px red",
};

class ConfirmationWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpened: false,
    };
  }

  openDialog() {
    this.setState({ dialogOpened: true });
  }

  closeDialog() {
    this.setState({ dialogOpened: false });
  }

  buttonCancel() {
    this.props.cancelClick && this.props.cancelClick(); // [Optional prop]
    this.closeDialog();
  }

  buttonConfirm() {
    this.props.confirmClick();
    this.closeDialog();
  }

  render() {
    return (
      <div>
        {this.props.disableConfirmations ? (
          <div>{this.props.children}</div>
        ) : (
          <div style={styleDev} onClick={this.openDialog.bind(this)}>
            {this.props.children}
          </div>
        )}

        <Dialog
          aria-labelledby="simple-dialog-title"
          open={this.state.dialogOpened}
          className="dialog"
        >
          <DialogTitle id="simple-dialog-title">
            {this.props.title || "Confirm Change"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {this.props.confirmationMessage || ""}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.buttonCancel.bind(this)}
              variant="contained"
              color="default"
            >
              Cancel
            </Button>
            <Button
              onClick={this.buttonConfirm.bind(this)}
              variant="contained"
              color="primary"
              autoFocus
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default ConfirmationWrapper;
